export default {
    required: "È richiesto un valore",
    email: "Il valore non è un indirizzo email valido",
    mask: "Il valore non è valido",
    maxValue: "Il valore massimo è {max}",
    maxLength: "La lunghezza massima consentita è {max}",
    regex: "Il valore non è valido",
    server: {
        DELEGATES_NOT_ENABLED: "I delegati non sono abilitati per questo partner.",
        DELEGATE_DOES_NOT_EXIST: "Il delegato non esiste",
        DELEGATE_UPDATE_PERMISSIONS_MISMATCH: "Non è possibile aggiornare un delegato che non ti appartiene.",
        DELEGATE_DELETE_PERMISSIONS_MISMATCH: "Non è possibile eliminare un delegato che non ti appartiene.",
        DELEGATE_ALREADY_EXISTS: "Esiste già una regola delegata esistente che corrisponde a questi criteri.",
        DELEGATE_CANNOT_BE_SELF: "Non puoi aggiungerti come delegato.",
        IMPERSONATE_USER_NO_PERMISSIONS: "L'utente {email} non ha accesso a DXC Gear e non è possibile effettuare alcun ordine per suo conto",
        INVALID_CART_ITEM: "Prodotto {product} non consentito",
        INVALID_USER_TYPE: "Il tipo di utente non è un dipendente",
        INVALID_EMPLOYMENT_STATUS: "L'utente non è un dipendente attivo",
        USER_NOT_FOUND: "Utente non trovato",
        "Invalid user type": "Tipo di utente non valido",
        "User not found": "Utente non trovato"
    }
}